var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lfs-alert"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}}),_c('div',{staticClass:"lfs-alert-btn",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n    "+_vm._s(_vm.btn)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }